import(/* webpackMode: "eager" */ "/opt/build/repo/apps/studio-web/styles/globals.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/apps/studio-web/styles/fonts.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/next/dist/client/script.js");
